import api from "../index";

// Check if the user is an admin
export const currentAdmin = async () => {
  return await api.post("/currentAdmin", {});
};

// Get all admin generations
export const getAllAdminGenerations = async () => {
  return await api.get("/admin/generations");
};

// Get all admin generations paginated
export const getAllAdminGenerationsPaginated = async (
  page: any,
  perPage: any,
  searchText: any
) => {
  if (!searchText) {
    return await api.get(
      `/admin/generations/paginated?page=${page}&perPage=${perPage}`
    );
  } else {
    return await api.get(
      `/admin/generations/paginated?page=${page}&perPage=${perPage}&searchText=${searchText}`
    );
  }
};

// Get all admin chats paginated
export const getAllAdminChatsPaginated = async (
  page: any,
  perPage: any,
  searchText: any
) => {
  if (!searchText) {
    return await api.get(
      `/admin/chats/paginated?page=${page}&perPage=${perPage}`
    );
  } else {
    return await api.get(
      `/admin/chats/paginated?page=${page}&perPage=${perPage}&searchText=${searchText}`
    );
  }
};

// Get admin subscription
export const getAdminSubscription = async () => {
  return await api.get("/admin/subscription");
};

// Get all admin generation archives paginated
export const getAllAdminGenerationArchivesPaginated = async (
  page: any,
  perPage: any,
  searchText: any
) => {
  if (!searchText) {
    return await api.get(
      `/admin/archives/generations/paginated?page=${page}&perPage=${perPage}`
    );
  } else {
    return await api.get(
      `/admin/archives/generations/paginated?page=${page}&perPage=${perPage}&searchText=${searchText}`
    );
  }
};

// Get all admin chat archives paginated
export const getAllAdminChatArchivesPaginated = async (
  page: any,
  perPage: any,
  searchText: any
) => {
  if (!searchText) {
    return await api.get(
      `/admin/archives/chats/paginated?page=${page}&perPage=${perPage}`
    );
  } else {
    return await api.get(
      `/admin/archives/chats/paginated?page=${page}&perPage=${perPage}&searchText=${searchText}`
    );
  }
};

// Get admin analytics
export const getAdminAnalytics = async (dateRange?: string) => {
  const params = dateRange ? `?dateRange=${dateRange}` : "";
  return await api.get(`/admin/analytics${params}`);
};

// Send team invite
export const sendTeamInvite = async (values: any) => {
  return await api.post("/admin/team/invite", values);
};

// Validate team invite token
export const validateTeamInvite = async (token: string) => {
  return await api.post("/admin/team/invite/validate", { token });
};

// Accept team invite (new user)
export const acceptTeamInvite = async (values: any) => {
  return await api.post("/admin/team/account/activate", values);
};

// Accept team invite (existing user)
export const acceptTeamInviteExistingUser = async (token: string) => {
  return await api.post("/admin/team/invite/accept-existing", { token });
};

// Get all team members
export const getTeamMembers = async () => {
  return await api.get("/admin/team/members");
};

// Get pending invitations
export const getPendingInvitations = async () => {
  return await api.get("/admin/team/invitations");
};

// Revoke invitation
export const revokeInvitation = async (email: string) => {
  return await api.delete(`/admin/team/invitation/${encodeURIComponent(email)}`);
};

// Remove team member
export const removeTeamMember = async (memberId: any) => {
  return await api.delete(`/admin/team/member/${memberId}/remove`);
};

// Get admin usages
export const getAdminUsages = async () => {
  return await api.get("/admin/usages");
};

// Get usage metrics by id
export const getUsageMetricsById = async (usageMetricsId: any) => {
  return await api.get(`/admin/usage-metrics/${usageMetricsId}`);
};
